import { useQuery as useTopRetailersQuery } from "@faire/web-api--source/api/retailer/productToken/top-retailers/get-hooks";
export var useTopRetailers = function(param) {
    var productToken = param.productToken;
    var data = useTopRetailersQuery(productToken !== null && productToken !== void 0 ? productToken : "", {
        enabled: !!productToken
    }).data;
    var _data_online_retailers;
    var online_retailers = (_data_online_retailers = data === null || data === void 0 ? void 0 : data.online_retailers) !== null && _data_online_retailers !== void 0 ? _data_online_retailers : [];
    var _data_brick_and_mortar_retailers;
    var brick_and_mortar_retailers = (_data_brick_and_mortar_retailers = data === null || data === void 0 ? void 0 : data.brick_and_mortar_retailers) !== null && _data_brick_and_mortar_retailers !== void 0 ? _data_brick_and_mortar_retailers : [];
    return {
        online_retailers: online_retailers,
        brick_and_mortar_retailers: brick_and_mortar_retailers
    };
};
